// extracted by mini-css-extract-plugin
module.exports = {"stepper-container":"IncrementStepper_stepper-container__hM_RU","base":"IncrementStepper_base__UP7Od","outline":"IncrementStepper_outline__6QBUk"};